import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  selector: {
    width: '40%',
  },
  productSelectorContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    '& .Mui-disabled': {
      color: '#6A777A !important' as const,
      WebkitTextFillColor: '#6A777A !important' as const,
    },
  },
  textField: {
    width: '439px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: '24px',
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
}))
